export const error = state => state.error
export const isLoading = state => state.isLoading
export const items = state => state.items
export const totalItems = state => state.totalItems
export const view = state => state.view
export const currentPage = state => state.currentPage
